import { PersonRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

const DefaultIncompleted = ({ title }) => (
  <Box display="flex" flexDirection="column" height="100%">
    {/* Placeholder Body */}
    <Box
      flex={1}
      display="flex"
      flexDirection={"column"}
      alignItems="center"
      justifyContent="center"
      maxWidth={350}
      margin={"auto"}
      textAlign={"center"}
      gap={2}
    >
      <Box
        sx={{
          borderRadius: "100%",
          height: "72px",
          width: "72px",
          background: "#EEEEEE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <PersonRounded sx={{ color: "#d1d1d1", fontSize: "52px" }} />
      </Box>
      <Typography variant="title1">Account is not connected</Typography>
      <Typography variant="body2" color="text.secondary">
        To complete the integration securely, please reach out to our team.
        We’ll help you get your account connected.{" "}
        <a href="mailto:support@adyogi.com">
          Contact Support Request Connection
        </a>
      </Typography>
    </Box>
  </Box>
);

export default DefaultIncompleted;